import React from 'react';
import { AllClaims } from '../../components/client/AllClaims';

export const Messages = () => {
  // Only show claims with this payment status
  const hasChat = true;
  const unreadFirst = true;
  return (
    <>
      <AllClaims hasChat={hasChat} unreadFirst={unreadFirst} />
    </>
  );
};
